module.exports = __webpack_public_path__ + "img/Logo-mob.7341e0ad.svg";